module.exports = __webpack_public_path__ + "img/ico_wl1.4bbe875f.png";